import { createSelector } from 'reselect';

const selectMoments = state => state.moments;
const selectChannels = state => state.channels;
const selectNotifications = state => state.notifications;

export const makeMomentsCount = createSelector(
    [selectMoments],
    moments => {
        if (moments.all && moments.all.posts) {
            return Object.keys(moments.all.posts).length;
        } else {
            return 0;
        }
    },
);

export const makeChannelsCount = createSelector(
    [selectChannels],
    channels => {
        if (channels.channels) {
            return Object.keys(channels.channels).length;
        } else {
            return 0;
        }
    },
);

export const makeNotificationsCount = createSelector(
    [selectNotifications],
    notifications => {
        if (notifications.data) {
            return Object.keys(notifications.data).length;
        } else {
            return 0;
        }
    },
);

export const makeModuleCounts = createSelector(
    [makeMomentsCount, makeChannelsCount, makeNotificationsCount],
    (moments, channels, notifications) => {
        return { moments, channels, notifications };
    },
);
